import { defineMessages } from 'react-intl-next';

const _default_1: {
	followAiMateButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	stopGeneratingButtonLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	thinkingText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	thinkingTextShort: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	editingText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	editingTextShort: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	escapeKeyHint: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	followAiMateButton: {
		id: 'ai-mate.inline-chat-input.follow-button.label',
		defaultMessage: 'Follow',
		description: 'Label for the follow AI mate button',
	},
	stopGeneratingButtonLabel: {
		id: 'ai-mate.inline-chat-input.stop-generating-button.label',
		defaultMessage: 'Stop generating',
		description: 'Label for the stop generating button',
	},
	thinkingText: {
		id: 'ai-mate.inline-chat-input.thinking',
		defaultMessage: 'Rovo is analyzing',
		description: 'Text displayed when the assistant is processing a request.',
	},
	thinkingTextShort: {
		id: 'ai-mate.inline-chat-input.thinking.short',
		defaultMessage: 'Analyzing',
		description:
			'Shortened text displayed when the assistant is processing a request in chromeless/inline comment contexts.',
	},
	editingText: {
		id: 'ai-mate.inline-chat-input.editing',
		defaultMessage: 'Rovo is editing',
		description: 'Text displayed when the assistant is editing a request.',
	},
	editingTextShort: {
		id: 'ai-mate.inline-chat-input.editing.short',
		defaultMessage: 'Editing',
		description:
			'Shortened text displayed when the assistant is editing a request in chromeless/inline comment contexts.',
	},
	escapeKeyHint: {
		id: 'ai-mate.inline-chat-input.escape-key-hint',
		defaultMessage: 'Esc',
		description:
			'Label for the Escape key hint displayed as a visual affordance next to the stop generating button. Shows users they can press the Escape key to cancel the AI generation. Displayed only in non-whiteboard contexts (e.g., editors, comments). Keep this short as it displays in a constrained UI area with subtle styling.',
	},
});
export default _default_1;
